import { components, ControlProps } from 'react-select';

// Import styles
import { Label } from './styles';

// Import types
import type { SelectOption } from 'types/views/form';

type Props = ControlProps<SelectOption, false> & {
	label: string;
	isError: boolean;
};

export const Control = ({ label, isError, ...rest }: Props) => (
	<>
		<Label $transform={rest.isFocused || rest.hasValue} isError={isError}>
			{label}
		</Label>
		<components.Control {...rest} />
	</>
);
